import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/** Scrolls to top on every route change. Render once near the router root. */
export function ScrollToTop() {
  const { pathname } = useLocation()
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' })
  }, [pathname])
  return null
}
